<!--
 * @Author: xiaokun
 * @Date: 2020-04-11 11:28:09
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-12 14:21:24
 * @Description: 已选问题 每个组件
 -->
<template>
  <div class="question-item border-attribute">
    <div class="question-answer">
      <div class="question-content">
        <slot name="question-serial-number" />
        {{ itemData.title }}
      </div>
      <div class="answer-content">
        正确答案：{{ itemData.answer.content }}
      </div>
    </div>
    <div class="handle">
      <div class="score">
        分数
        <el-input-number
          v-model="itemData.score"
          :width="50"
          :min="1"
          :max="100"
          :step-strictly="true"
          :controls="false"
          :disabled="curSameState"
          @blur="updateScore"
        />
        分
      </div>
      <div class="handele">
        <span
          v-if="position!=='first'"
          class="operate cursor"
          @click="moveUp"
        >
          上移
        </span>
        <span
          v-if="position!=='last' && questionsLength>1"
          class="operate cursor"
          @click="moveDown"
        >
          下移
        </span>
        <span
          class="operate cursor"
          @click="moveDelete"
        >
          删除
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    position: {
      type: String,
      default: ''
    },
    // 当前数组长度
    questionsLength: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  computed: {
    curSameState () {
      return this.$store.state['examination-manage'].curSameState
    }
  },
  watch: {},
  created () {},
  mounted () {
  },
  methods: {
    // 上移
    moveUp () {
      this.$emit('on-move-item-click', 'up')
    },
    // 下移
    moveDown () {
      this.$emit('on-move-item-click', 'down')
    },
    // 删除
    moveDelete () {
      this.$emit('on-move-item-click', 'delete')
      this.$emit('on-move-item-click', 'update')
    },
    // 改变分数
    updateScore (val) {
      this.$emit('on-move-item-click', 'update')
    }
  }
}
</script>
<style lang='scss' scoped>
.question-item {
  margin-bottom: 20px;
  line-height: 18px;
  font-size: 13px;

  /deep/.el-input-number {
    height: 28px;
    width: 50px;
    display: inline-block;
    margin-right: 5px;

    .el-input {
      height: 28px;
      width: 50px;
      display: inline-block;

      .el-input__inner {
        padding: 0;
        height: 28px;
        width: 50px;
      }
    }
  }

  .question-answer {
    padding: 15px 20px;
    word-break: break-all;
    border-bottom: 1px solid #e8e8e8;

    .question-content {
      font-weight: 500;
      padding-bottom: 10px;
    }
  }

  .handle {
    padding: 6px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .score {
      display: flex;
      align-items: center;

      /deep/ .el-input-number {
        margin-left: 5px;
        display: inline-table;
      }
    }

    .operate {
      color: #009cff;
      margin-left: 15px;
    }
  }
}
</style>
